import { AccountContext } from 'components/AccountContext';
import { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const useLogin = () => {
  const [isPasswordHidden, setIsPasswordHidden] = useState(true);
  const handleSeePass = () => setIsPasswordHidden(!isPasswordHidden);
  const navigate = useNavigate();
  const { setUser } = useContext(AccountContext);
  const onlyNumbers = (str) => str.replace(/[^0-9]/g, '');
  const [loading, setLoading] = useState(false);

  const [error, setError] = useState(null);

  return { isPasswordHidden, handleSeePass, navigate, onlyNumbers, error, setError, setUser, loading, setLoading };
};

export default useLogin;
